<script>
  import { noop } from 'svelte/internal';
  import { _ } from 'svelte-intl';
  import Bundle from './Bundle.svelte';

  export let title = $_('coin_shop_bundles');
  export let bundles; // Bundle[]
  export let focusPrice; // number?
  export let onSelectBundle = noop; // (Bundle) => void

  let expanded = false;
  let showBundles;
  $: if (focusPrice && !expanded) {
    showBundles = [bundles.find((b) => b.coinsAmount >= focusPrice)];
  } else {
    showBundles = bundles;
  }

  const expand = () => {
    expanded = true;
  };

  const collapse = () => {
    expanded = false;
  };
</script>

<style lang="stylus">
  .bundles
    margin-top 32px

  h2
    font-size 20px
    margin-bottom 16px

  ul
    list-style: none
    padding: 0
    margin: 0
    margin-bottom 24px


  .more
    display block
    text-align center
</style>

<div class="bundles">
  {#if title}
    <h2>{title}</h2>
  {/if}
  <ul>
    {#each showBundles as bundle}
      <Bundle {bundle} onSelect={onSelectBundle} />
    {/each}
  </ul>
  {#if focusPrice}
    {#if !expanded}
      <a href="./" class="more" on:click|preventDefault={expand}>{$_('more_bundles')}</a>
    {:else}
      <a href="./" class="more" on:click|preventDefault={collapse}>{$_('less_bundles')}</a>
    {/if}
  {/if}
</div>
